<div class="card product-card">
  <div class="card-body">
    <span class="favourite-icon-wrapper">
      <lib-favourite-product-icon [id]="data.product.id"></lib-favourite-product-icon>
    </span>
    <div class="image-wrapper cursor-pointer" (click)="goToDetail(data.product)">
      <img
        class="img-fluid"
        *ngIf="data.product.extra && data.product.extra.images && data.product.extra.images[0]"
        [src]="data.product.extra.images[0].s3Uri | gungImageUrl
          :'type:list'
          :'etag:'+data.product.extra.images[0].s3ETag
        "
        alt=""
      />
    </div>
    <div class="product-text">
      <div>{{ data.product?.extra?.gme?.displayId || data.product.id }}</div>
      <div class="text-truncate" translate>{{ data.product?.extra?.gme?.displayName || data.product.name }}</div>
      <!--<div class="d-block" *ngFor="let value of data.product.dynamicCollumnsValues">{{value}}</div>-->
      <div *ngIf="data.price && !isAnonymous" class="row">
        @if (priceConfigService.productGridCardV2NetGrossPriceDisplay && data?.price?.customerDiscountPercent && !environment?.displayPriceLevels) {
          <div translate class="col-12 font-weight-bold">
            <div class="d-flex flex-row flex-wrap justify-content-between">
              <lib-price [price]="data.price" type="customerNetPrice" class="mr-2" [priceLevelsDisplayType]="'COMPACT_GRID'"></lib-price>
              <span class='text-muted'>
                <lib-price [price]="data.price" type="customerGrossPrice"></lib-price>
                <small> (-{{ data.price.customerDiscountPercent }}%)</small>
              </span>
            </div>
          </div>

          <div class="col-auto">
            <span *ngIf="data.price.recommendedRetailPrice && data.price.recommendedRetailPrice.value > 0">
              {{ 'RRP' | translate }}
              <lib-price [price]="data.price" type="RRP"
                [currency]="data.price.recommendedRetailPrice.currencyCode"></lib-price>
            </span>
          </div>
        } @else {
          <div translate class="col-auto font-weight-bold">
            @if (!isStandardErp) {
              <lib-price [price]="data.price" type="customerNetPrice" [priceLevelsDisplayType]="'COMPACT_GRID'"></lib-price>
            } @else {
              <span><lib-price [price]="data.price" type="customerNetPrice" [priceLevelsDisplayType]="'COMPACT_GRID'"></lib-price> @if (data.price?.customerDiscountPercent) {(-{{ data.price.customerDiscountPercent }}%)}</span>
            }
          </div>

          <div class="col-auto ml-auto">
            <span *ngIf="data.price.recommendedRetailPrice && data.price.recommendedRetailPrice.value > 0">
              {{ 'RRP' | translate }}
              <lib-price [price]="data.price" type="RRP"
                [currency]="data.price.recommendedRetailPrice.currencyCode"></lib-price>
            </span>
          </div>
        }
      </div>
      <lib-availability [availability]="data.availability" [isSales]="isSales" *ngIf="includeAvailability && !isAnonymous" [product]="data.product">
      </lib-availability>
      <div class="product-card-button text-center">
        <container-element [ngSwitch]="data.product?.productType" *ngIf="!isAnonymous;else details">
          <button *ngSwitchCase="'concept'" class="btn btn-sm btn-primary" (click)="goToDetail(data.product)" translate>
            SHOW_PRODUCTS
          </button>
          <lib-buy-button-wrapper *ngSwitchDefault [product]="data.product" [availability]="data.availability" [price]="data?.price"></lib-buy-button-wrapper>
        </container-element>
        <ng-template #details>
          <button class="btn btn-sm btn-primary" (click)="goToDetail(data.product)" translate>
            DETAILS
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
